<div class="container-fluid content-wrapper pt-5" style="margin-top:3rem;">
    <div class=" ">
      <div class="text-center">
        <h5 class="card-title">View All Migration Requests</h5>
      </div>
      <div class="card-body">
        <!-- <div class="row mb-4">
            <div class="col-md-3"></div>
            <div class="col-md-2">
              <label for="selectyear" class="form-label" >Select Year:</label>
              </div>
              <div class="col-md-4">
              <select class="form-select" (change)="getallrequestyearwise($event.target)">
                <option selected hidden [attr.disabled]="true" value="">Select year</option>
                <option value="lt2011">Before 2011</option>
                <option value="gt2011">After 2011</option>
              </select>
              <div  class="invalid-feedback">
                <div >Please select camp</div>
              </div>
            </div>  
        </div> -->
       <div class="row">
            <div *ngIf="tblvisible" class="col-md-12">
              <div style="height: 100%; box-sizing: border-box;">
                <ag-grid-angular
                 #agGrid
                  style="width: 100%; height:450px;"
                  class="ag-theme-alpine"
                  [columnDefs]="columnDefs"
                  [defaultColDef]="defaultColDef"
                  [pagination]="true"
                  [paginationPageSize]="10"
                  [rowData]="rowData[0]"
                  [animateRows]="true"
                ></ag-grid-angular>
              </div>
            </div>
            <div *ngIf="!tblvisible" class=" mx-auto">             
                <div class="alert alert-secondary text-center com-md-3">
                  <p class="h5"><i class="bi bi-list-check"></i><br>{{noselectionmsg}}</p>
              </div>
              
            </div>
       </div>
    </div>
  </div>
  <div *ngIf="tblvisible" style="text-align: end;" class="mt-1">
  <button class="btn btn-primary" (click) ="onBtExport()">Download to Excel
  </button>
  </div>
  </div>
  
 <!----modal-->
 <div class="modal fade" data-bs-backdrop="static" id="candidateprofile" tabindex="-1"  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
    
      <div class="modal-body">
                <div class="card border-secondary mb-3">
                      <div class="card-header d-flex">
                        <h5 class="card-title" style="width: 100%;">Application Id: {{appid}}/{{exam_month_year}}/{{standard}}/{{seat_no}}
                        </h5>
                        <div class="text-end" style="width: 100%;">
                        <button type="button" class="btn-close text" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                      <div class="card-body"  style="height:590px;width:100%;overflow:scroll;overflow-x:hidden;overflow-y:scroll;">
                        <form method="post" role="form" #form="ngForm" [formGroup]="Requestform" (ngSubmit)="onSubmit(Requestform.value)">
                            <div class="form-group">
                                <div class="row">
                                          <div class="col-md-8">
                                            <p><label class="control-label">Full name as shown in the Marksheet: <span class="strip"> {{varified_correct_name}}</span></label></p>
                                            <label class="control-label">Entered Name:<span class="strip">* {{varified_name_check}}</span></label>
                                            <input type="text" formControlName="stud_name" name="stud_name" id="stud_name"   class="form-control" placeholder="Full name as shown in the marksheet card"
                                            [ngClass]="{ 'is-invalid': submitted && f.stud_name.errors }" />
                                            <div *ngIf="submitted && f.stud_name.errors" class="invalid-feedback">
                                                <div *ngIf="f.stud_name.errors.required">Full name is required</div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                          <p><label class="control-label"></label></p>
                                            <label class="control-label">Applied For<span class="strip">*</span></label>
                                            <input type="text" [attr.disabled]="true" formControlName="application_type" name="application_type" id="application_type"   class="form-control" > 
                                        </div>
                                </div>
                            </div>
                            
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="control-label">Email:<span class="strip">*</span></label>
                                        <div class="">
                                            <input type="text" [attr.disabled]="true" formControlName="email_address" name="email_address" id="email_address" placeholder="Email" class="form-control ng-pristine ng-untouched ng-valid" value=""/>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="control-label"> Mobile:<span class="strip"></span></label>
                                        <div>
                                            <input type="number" formControlName="mobile_no" [attr.disabled]="true" name="mobile"  placeholder="Mobile number" class="form-control" value="9922440953"  
                                            [ngClass]="{ 'is-invalid': submitted && f.mobile_no.errors }" maxlength="10" minlength="10"/> 
                                                    <div *ngIf="submitted && f.mobile_no.errors" class="invalid-feedback">
                                                <div *ngIf="f.mobile_no.errors.required">Mobile no. is required</div>                                             
                                             </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">                                       
                                            <label class="control-label">Standard<span class="strip">*</span></label>
                                           <input type="text" [attr.disabled]="true"  formControlName="standard"  name="standard" id="standard" class="form-control"  maxlength="50" value=""/>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-8">
                                        <label class="control-label">Address:<span class="strip">*</span></label>
                                        <div class="">
                                            <textarea  rows="3" formControlName="address"  name="address" id="address" class="form-control" 
                                            [ngClass]="{ 'is-invalid': submitted && f.address.errors }"></textarea>
                                            <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                                              <div *ngIf="f.address.errors.required">Address is required</div>                                             
                                           </div>
                                        </div>
                                    </div> 
                                    <div class="col-md-4">
                                        <label class="control-label"> Pincode:<span class="strip"></span></label>
                                        <div class="">
                                          <input type="number" formControlName="pincode"  name="pincode" id="pincode" class="form-control"
                                          [ngClass]="{ 'is-invalid': submitted && f.pincode.errors }">
                                          <div *ngIf="submitted && f.pincode.errors" class="invalid-feedback">
                                            <div *ngIf="f.pincode.errors.required">Pincode is required</div>                                             
                                         </div>
                                        </div>                                      
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="control-label">Month and Year of {{standard}} exam<span class="strip">*</span></label>
                                        <div class="">
                                            <input type="text" [attr.disabled]="true" formControlName="exam_month_year"  name="exam_month_year" id="exam_month_year"  class="form-control"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="control-label">Seat no of {{standard}} exam:<span class="strip">*</span></label>
                                        <div class="">
                                            <input type="number" [attr.disabled]="true"  formControlName="seat_no"  name="seat_no" id="seat_no"  placeholder="Seat no of last exam" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && f.seat_no.errors }"/>
                                            <div *ngIf="submitted && f.seat_no.errors" class="invalid-feedback">
                                              <div *ngIf="f.seat_no.errors.required">Seat no. is required</div>
                                                </div>
                                        </div>
                                    </div>                                    
                                    </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="row">
                                        <div class="col-md-6">
                                             <div class="" >
                                                   <label class="control-label">School Index:<span class="strip">*</span></label>
                                                <div class="">
                                                  <input type="text" formControlName="school_name" [attr.disabled]="true" placeholder="" class="form-control" >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="" >
                                                   <label class="control-label">Certificate reciept mode :<span class="strip">*</span></label>
                                                <div class="">
                                                  <input type="text" formControlName="certificate_delivery_mode" [attr.disabled]="true" placeholder="" class="form-control"  >
                                                </div>
                                            </div>
                                        </div>    
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="row">
                                        <div class="col-md-6">
                                             <div class="" >
                                                <label for="designation" class="col-form-label">Uploaded Photo<span>*</span></label>
                                                <input *ngIf="!photoinfo" type="file" id="designation" class="form-control"  > 
                                                <div *ngIf="photoinfo" class="col-md-6">
                                                    <!-- Preview -->
                                                     <!-- <button type="button" class="btn btn-outline-success" >
                                                       Preview Uploaded Photo
                                                     </button> -->
                                                     <img id="myImg" src="{{photoinfo}}"  (click)="openmodal('photoModal')" alt="Profile Photo" >
    
                                                     <!-- The Modal -->
                                                     <div id="photoModal" class="modal1">
                                                       <span class="close1" (click)="closemodal('photoModal')">&times;</span>
                                                       <img class="modal-content1" id="img01">
                                                       <div id="caption">
                                                         <img  src="{{photoinfo}}">
                                                       </div>
                                                     </div>
                                                     
                               
                                               </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="" >
                                                <label for="inputEmail3" class="col-form-label">Upload Marksheet<span>*</span></label>
                                                <div *ngIf="marksinfo" class="col-md-6">
                                                   <a [href]="marksinfo" target="_blank" class="ml-2 btn btn-success" download>Download</a>
                                                </div>
                                            
                                                <input type="file" accept="application/pdf" formControlName="upload_marksheet" id="upload_marksheet" class="form-control mt-3" 
                                                  [ngClass]="{ 'is-invalid': submitted && f.upload_marksheet.errors }" (change)="getmarksheet($event)"/>
                                                  <div *ngIf="submitted && f.upload_marksheet.errors" class="invalid-feedback">
                                                    <div *ngIf="f.upload_marksheet.errors.required">Please Upload Marksheet</div>
                                                  </div>
                                            </div>
                                        </div>    
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <div class="row">                                      
                                        <div class="col-md-6">
                                            <div class="" >
                                                <label  class="col-form-label">Payment Status<span>*</span></label>                                         
                                                <select formControlName="payment_status" class="form-control" [attr.disabled]="true"  [ngClass]="{ 'is-invalid': submitted && f.payment_status.errors }">
                                                      <option selected hidden [disabled]="true">Select Payment Status</option>
                                                      <option value="Paid">Paid</option>
                                                      <option value="Unpaid">Unpaid</option>
                                                </select>
                                                <div *ngIf="submitted && f.payment_status.errors" class="invalid-feedback">
                                                  <div *ngIf="f.payment_status.errors.required">Please Select Status</div>
                                                </div>
                                            </div>
                                        </div>  
                                         <div class="col-md-6">
                                          <div class="" >
                                            <!-- <div class="form-check mt-5">
                                              <input formControlName="physicalcheck" class="form-check-input"
                                                type="checkbox" [attr.checked]="physicalDoccheck"  id="physicalcheck"  [ngClass]="{ 'is-invalid': submitted && f.physicalcheck.errors }">
                                                <label class="form-check-label" for="physicalcheck">
                                                 Physical Copy Received
                                                </label> -->
                                                <!-- <div *ngIf="submitted && f.physicalcheck.errors" class="invalid-feedback">
                                                  <div *ngIf="f.physicalcheck.errors.required">Please Upload Marksheet</div>
                                                </div> -->
                                            <!-- </div>-->
                                            <label  class="col-form-label">Physical Copy of Documents:<span>*</span></label>   
                                            <select formControlName="physicalcheck" class="form-select">
                                                  <option selected hidden disabled value="">Select </option>
                                                  <option value="Received">Received</option>
                                                  <option value="Not Received">Not Received</option>
                                            </select>
                                          </div>
                                        </div>   
                                      </div>
                                    </div>
                                    <div class="actions">
                                        <ul>
                                           <li aria-hidden="false" aria-disabled="false" *ngIf="varified_name_check">
                                            <input value="Reject" type="button" (click)="direct_reject_request()" class="btn btn-danger  btn-block btnlogin  m-1" >
                                          </li>
                                           <li aria-hidden="false" aria-disabled="false">
                                            <input value="Update" type="submit" class="btn btn-warning  btn-block btnlogin  m-1" >
                                          </li>
                                          <li aria-hidden="Cancel" aria-disabled="false">
                                            <!-- <input value="Generate Certificate" type="button" class="btn-info btn  btn-block btnlogin  m-1" (click)="generateCertificate()"> -->
                                            <input value="Cancel" type="button" class="btn-secondary btn  btn-block btnlogin  m-1" data-bs-dismiss="modal" aria-label="Close">
                                          </li>
                                        </ul>
                                    </div>
                                    
                    </form>
                        </div>
                </div>
                
 </div>
 </div>
 </div>
 
 </div>
<!-- modal end -->
<!-- view Photo Modal -->
<!-- <div *ngIf="showphoto" class="modal fade" data-bs-backdrop="static"  id="photopreview"  tabindex="-1" >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header modalheader ">
          <h5 class="modal-title" id="exampleModalLabel">Uploaded Photo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
         </div>
         <div class="modal-body viewimgmodalbody">
             
             <h5 class="modal-title" id="exampleModalLabel">Uploaded Photo</h5>
            <img [src]="photoinfo">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>   -->

<!--  -->
  
